import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import a from "../Assets/virasat-2023/IMG_0214.jpg";
import b from "../Assets/virasat-2023/IMG_0219.jpg";
import c from "../Assets/virasat-2023/IMG_0298.jpg";
import d from "../Assets/virasat-2023/IMG_0307.jpg";
import e from "../Assets/virasat-2023/IMG_0314.jpg";
import f from "../Assets/virasat-2023/IMG_0332.jpg";
import g from "../Assets/virasat-2023/IMG_0336.jpg";
import h from "../Assets/virasat-2023/IMG_0337.jpg";
import i from "../Assets/virasat-2023/IMG_0338.jpg";
import j from "../Assets/virasat-2023/IMG_0344.jpg";
import k from "../Assets/virasat-2023/IMG_0358.jpg";
import l from "../Assets/virasat-2023/IMG_0423.jpg";
import m from "../Assets/virasat-2023/IMG_0436.jpg";
import n from "../Assets/virasat-2023/IMG_0452.jpg";
import o from "../Assets/virasat-2023/IMG_0461.jpg";
import p from "../Assets/virasat-2023/IMG_0474.jpg";
import q from "../Assets/virasat-2023/IMG_0477.jpg";

import a1 from "../Assets/virasat-2023/IMG_0482.jpg";
import b1 from "../Assets/virasat-2023/IMG_0495.jpg";
import c1 from "../Assets/virasat-2023/IMG_0512.jpg";
import d1 from "../Assets/virasat-2023/IMG_0516.jpg";
import e1 from "../Assets/virasat-2023/IMG_0522.jpg";
import f1 from "../Assets/virasat-2023/IMG_0546.jpg";
import g1 from "../Assets/virasat-2023/IMG_0584.jpg";
import h1 from "../Assets/virasat-2023/IMG_0599.jpg";
import i1 from "../Assets/virasat-2023/IMG_0602.jpg";
import j1 from "../Assets/virasat-2023/IMG_0662.jpg";
import k1 from "../Assets/virasat-2023/IMG_0666.jpg";
import l1 from "../Assets/virasat-2023/IMG_0703.jpg";
import m1 from "../Assets/virasat-2023/IMG_0716.jpg";
import n1 from "../Assets/virasat-2023/IMG_0723.jpg";
import o1 from "../Assets/virasat-2023/IMG_0726.jpg";
import p1 from "../Assets/virasat-2023/IMG_0727.jpg";
import q1 from "../Assets/virasat-2023/IMG_0728.jpg";

import r1 from "../Assets/virasat-2023/IMG_0732.jpg";
import s1 from "../Assets/virasat-2023/IMG_0744.jpg";
import t1 from "../Assets/virasat-2023/IMG_0754.jpg";
import u1 from "../Assets/virasat-2023/IMG_0769.jpg";

import a2 from "../Assets/virasat-2023/IMG_0773.jpg";
import b2 from "../Assets/virasat-2023/IMG_0774.jpg";
import c2 from "../Assets/virasat-2023/IMG_0754.jpg";
import d2 from "../Assets/virasat-2023/IMG_0769.jpg";
import e2 from "../Assets/virasat-2023/IMG_0773.jpg";
import f2 from "../Assets/virasat-2023/IMG_0774.jpg";
import g2 from "../Assets/virasat-2023/IMG_0777.jpg";
import h2 from "../Assets/virasat-2023/IMG_0790.jpg";
import i2 from "../Assets/virasat-2023/IMG_0796.jpg";
import j2 from "../Assets/virasat-2023/IMG_0914.jpg";
import k2 from "../Assets/virasat-2023/IMG_0916.jpg";
import l2 from "../Assets/virasat-2023/IMG_0917.jpg";
import m2 from "../Assets/virasat-2023/IMG_0982.jpg";
import n2 from "../Assets/virasat-2023/IMG_0987.jpg";
import o2 from "../Assets/virasat-2023/IMG_0999.jpg";
import p2 from "../Assets/virasat-2023/IMG_1013.jpg";
import q2 from "../Assets/virasat-2023/IMG_1033.jpg";

import r2 from "../Assets/virasat-2023/IMG_1051.jpg";
import s2 from "../Assets/virasat-2023/IMG_1073.jpg";
import t2 from "../Assets/virasat-2023/IMG_1076.jpg";
import u2 from "../Assets/virasat-2023/IMG_1097.jpg";

import a3 from "../Assets/virasat-2023/IMG_1105.jpg";
import b3 from "../Assets/virasat-2023/IMG_1115.jpg";
import c3 from "../Assets/virasat-2023/IMG_1133.jpg";
import d3 from "../Assets/virasat-2023/IMG_1185.jpg";
import e3 from "../Assets/virasat-2023/IMG_1187.jpg";
import f3 from "../Assets/virasat-2023/IMG_1202.jpg";
import g3 from "../Assets/virasat-2023/IMG_1214.jpg";
import h3 from "../Assets/virasat-2023/IMG_1238.jpg";
import i3 from "../Assets/virasat-2023/IMG_1284.jpg";
import j3 from "../Assets/virasat-2023/IMG_1291.jpg";
import k3 from "../Assets/virasat-2023/IMG_1294.jpg";
import l3 from "../Assets/virasat-2023/IMG_1300.jpg";
import m3 from "../Assets/virasat-2023/IMG_1315.jpg";
import n3 from "../Assets/virasat-2023/IMG_1319.jpg";
import o3 from "../Assets/virasat-2023/IMG_1329.jpg";
import p3 from "../Assets/virasat-2023/IMG_1331.jpg";




const Virasat = () => {
    const images = [
        a,
        b,
        c,
        d,
        e,
        f,
        g,
        h,
        i,
        j,
        k,
        l,
        m,
        n,
        o,
        p,
        q,

        a1,
        b1,
        c1,
        d1,
        e1,
        f1,
        g1,
        h1,
        i1,
        j1,
        k1,
        l1,
        m1,
        n1,
        o1,
        p1,
        q1,
        r1,
        s1,
        t1,
        u1,

        a2,
        b2,
        c2,
        d2,
        e2,
        f2,
        g2,
        h2,
        i2,
        j2,
        k2,
        l2,
        m2,
        n2,
        o2,
        p2,
        q2,
        r2,
        s2,
        t2,
        u2,
        a3,
        b3,
        c3,
        d3,
        e3,
        f3,
        g3,
        h3,
        i3,
        j3,
        k3,
        l3,
        m3,
        n3,
        o3,
        p3,
    ];
    return (
        <div>
            <Header />
            <h1 style={{ textAlign: 'center', margin: '10px auto' }}>
                <u>Virasat 2023</u>
            </h1>

            <div className="container-fluid">
                <div className="row mt-4">
                    {images.map((image, index) => (
                        <div className="item col-sm-6 col-md-3 mb-3" key={index}>
                            <a href={image} className="fancybox" data-fancybox="gallery1">
                                <img
                                    src={image}
                                    width="100%"
                                    className="img-fluid height_set"
                                    alt={`Slide ${index + 1}`}
                                />
                            </a>
                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </div>
    );
};


export default Virasat;
